'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { GROUP_KEYS, FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_SERVICE_FREE, ONBOARDING_CMS_SIMPLIFIED, ONBOARDING_OPS_FREE_INEXPERIENCED, ONBOARDING_OPS_FREE_EXPERIENCED, ONBOARDING_OPS_FREE_HUBSPOT_EXPERIENCED // Consolidated Onboarding Keys
, ONBOARDING_MARKETING_FREE, ONBOARDING_SALES_FREE, ONBOARDING_CMS_FREE, ONBOARDING_FREE_SERVICE } from 'getting-started-shared-tasks/onboardingKeys';
import { ONBOARDING_VIEWS, setOnboardingSettings } from 'user-context/onboardingSettings';
import { setDefaultGroupKey } from 'user-context/onboarding';
import { CRM_SIGNUP, SALES_SIGNUP, SERVICE_SIGNUP, MARKETING_SIGNUP, CMS_FREE_SIGNUP } from '../constants/signupConstants';
import { EXPERIENCE_NONE_PARAM, EXPERIENCE_HAS_USED_HUBSPOT, EXPERIENCE_HAS_USED_CRM_PARAM, SURVEY_KEYS } from '../constants/surveyConstants';
import { HubletUrl } from '../utils/urls';
import { BASELINE_FOR_NON_CRM_SIGNUPS_GATE } from '../constants/gateConstants';
export const getServiceOnboardingKey = () => {
  return ONBOARDING_SERVICE_FREE;
};
export const getDefaultOnboardingSettings = (survey, gates = [], signupType) => {
  const {
    SALES,
    MARKETING,
    SERVICE,
    CMS,
    OPS
  } = ONBOARDING_VIEWS;
  const crmExperience = survey[SURVEY_KEYS.CRM_EXPERIENCE];
  const hasConsolidatedUserGuide = [CRM_SIGNUP, SALES_SIGNUP, MARKETING_SIGNUP].includes(signupType) || gates.includes(BASELINE_FOR_NON_CRM_SIGNUPS_GATE);

  if (hasConsolidatedUserGuide) {
    return {
      views: {
        [MARKETING]: {
          groupKey: FREE_GROUP_KEYS.freeMarketingView,
          onboardingKey: ONBOARDING_MARKETING_FREE
        },
        [SALES]: {
          groupKey: FREE_GROUP_KEYS.freeSalesView,
          onboardingKey: ONBOARDING_SALES_FREE
        },
        [SERVICE]: {
          groupKey: FREE_GROUP_KEYS.freeServiceView,
          onboardingKey: ONBOARDING_FREE_SERVICE
        },
        [CMS]: {
          groupKey: FREE_GROUP_KEYS.freeCmsView,
          onboardingKey: ONBOARDING_CMS_FREE
        }
      }
    };
  }

  const defaultServiceSettings = {
    groupKey: GROUP_KEYS.services,
    onboardingKey: ONBOARDING_SERVICE_FREE
  };
  const cmsSettings = {
    [CMS]: {
      groupKey: GROUP_KEYS.cmsV3,
      onboardingKey: ONBOARDING_CMS_SIMPLIFIED
    }
  };
  const defaultNonExperienceSettings = {
    views: Object.assign({
      [SALES]: {
        groupKey: FREE_GROUP_KEYS.freeSalesView,
        onboardingKey: ONBOARDING_SALES_FREE
      },
      [MARKETING]: {
        groupKey: FREE_GROUP_KEYS.freeMarketingView,
        onboardingKey: ONBOARDING_MARKETING_FREE
      },
      [SERVICE]: {
        groupKey: GROUP_KEYS.INEXPERIENCED_SIMPLIFIED_SERVICE,
        onboardingKey: ONBOARDING_SERVICE_FREE
      },
      [OPS]: {
        onboardingKey: ONBOARDING_OPS_FREE_INEXPERIENCED
      }
    }, cmsSettings)
  };

  switch (crmExperience) {
    case EXPERIENCE_NONE_PARAM:
      return defaultNonExperienceSettings;

    case EXPERIENCE_HAS_USED_CRM_PARAM:
      return {
        views: Object.assign({
          [SALES]: {
            groupKey: FREE_GROUP_KEYS.freeSalesView,
            onboardingKey: ONBOARDING_SALES_FREE
          },
          [MARKETING]: {
            groupKey: FREE_GROUP_KEYS.freeMarketingView,
            onboardingKey: ONBOARDING_MARKETING_FREE
          },
          [SERVICE]: defaultServiceSettings,
          [OPS]: {
            onboardingKey: ONBOARDING_OPS_FREE_EXPERIENCED
          }
        }, cmsSettings)
      };

    case EXPERIENCE_HAS_USED_HUBSPOT:
      return {
        views: Object.assign({
          [SALES]: {
            groupKey: FREE_GROUP_KEYS.freeSalesView,
            onboardingKey: ONBOARDING_SALES_FREE
          },
          [MARKETING]: {
            groupKey: FREE_GROUP_KEYS.freeMarketingView,
            onboardingKey: ONBOARDING_MARKETING_FREE
          },
          [SERVICE]: defaultServiceSettings,
          [OPS]: {
            onboardingKey: ONBOARDING_OPS_FREE_HUBSPOT_EXPERIENCED
          }
        }, cmsSettings)
      };

    default:
      return defaultNonExperienceSettings;
  }
};
export const getDefaultView = signupType => {
  switch (signupType) {
    case CRM_SIGNUP:
      return ONBOARDING_VIEWS.SALES;

    case MARKETING_SIGNUP:
      return ONBOARDING_VIEWS.MARKETING;

    case SALES_SIGNUP:
      return ONBOARDING_VIEWS.SALES;

    case SERVICE_SIGNUP:
      return ONBOARDING_VIEWS.SERVICE;

    case CMS_FREE_SIGNUP:
      return ONBOARDING_VIEWS.CMS;

    default:
      return ONBOARDING_VIEWS.SALES;
  }
};
export const setDefaultOnboardingSettings = (survey, hubOnboardingSettings, signupType, userId, portalId, logger, gates) => {
  if (!userId) {
    logger.error('No user id provided, skipping setting onboarding key');
    return Promise.resolve();
  }

  if (!portalId) {
    logger.error('No portal id provided, skipping setting onboarding key');
    return Promise.resolve();
  }

  const {
    view
  } = hubOnboardingSettings,
        overrideOnboardingSettings = _objectWithoutPropertiesLoose(hubOnboardingSettings, ["view"]);

  const onboardingSettings = getDefaultOnboardingSettings(survey, gates, signupType);

  if (view) {
    onboardingSettings.views[view] = Object.assign({}, onboardingSettings.views[view], {}, overrideOnboardingSettings);
    onboardingSettings.selectedView = view;
  }

  if (!onboardingSettings.selectedView) {
    onboardingSettings.selectedView = getDefaultView(signupType);
  }

  const apiUrl = HubletUrl.getApiUrl();
  const requestOptions = {
    hubletOriginOverride: apiUrl
  };
  const settingsRequests = [setOnboardingSettings(onboardingSettings, userId, portalId, requestOptions)]; // groupKey also needs to be set in usercontext-app for setting user's default task group

  const {
    groupKey
  } = hubOnboardingSettings;

  if (view && groupKey) {
    settingsRequests.push(setDefaultGroupKey(groupKey, requestOptions));
  }

  return Promise.all(settingsRequests);
};